/** @format */

import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "senf-shared";
import styled from "styled-components";
import theme from "../../../styles/theme";
import Box from "../../atoms/box/Box";
import DropdownButton from "../../atoms/dropdownButton/DropdownButton";
import Input from "../../atoms/inputs/Input";
import Typography from "../../atoms/typography/Typography";
import Button from "../../core/button/Button";
import Dropdown from "../../core/dropdown/Dropdown";
import type { ToolbarProps } from "./Toolbar.types";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: 0.5s;
  animation: ToolbarAnimation 0.7s;
  z-index: 9;
  flex-flow: wrap;

  @keyframes ToolbarAnimation {
    0% {
      opacity: 0;
      transform: translateY(10%);
    }
    20% {
      opacity: 0;
      transform: translateY(10%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`;

const SearchbarWrapper = styled.div`
  margin-top: 10px;
  /* display: relative; */
  width: 100%;
`;

const Toolbar: FC<ToolbarProps> = ({
  setSearchOpen,
  searchOpen,
  searchTerm,
  setSearchTerm,
  secondButton,
  searchPlaceholder,
  checkedSortOption,
  setCheckedSortOption,
  sortOptions,
}) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const setSearch = () => {
    setSearchOpen(!searchOpen);

    // if (useIsMobile) {
    //   dispatch(setSwipePositionUp());
    // }
  };

  return (
    <Wrapper>
      {/* {user?.isSuperAdmin ? (
        <Select
          labelOption="default"
          variant="basic"
          text={
            sortOptions.find(({ value }) => value === checkedSortOption)
              ?.label || "Select an attribute"
          }
          selectState="default"
          onValueChange={setCheckedSortOption}
          data={sortOptions.map((item) => ({
            value: item.value,
            text: item.label,
            // trackId: `sortOption_${item.value}Click`,
            // checked: checkedSortOption === item.value,
          }))}
        />
      ) : ( */}
      <Dropdown
        size="md"
        // trailingIcon="arrowhead-down-lg"
        asChild
        className="text-sm"
        prefix={t("global:sortBy")}
        text={
          sortOptions.find((option) => option.value === checkedSortOption)
            ?.label
        }
        items={Object.values(
          sortOptions as { label: string; value: string }[],
        ).map((item) => ({
          text: item?.label,
          trackId: `sortOption_${item.value}Click`,
          selected: checkedSortOption === item.value,
          leadingIcon: checkedSortOption === item.value && "checkmark-md",
          onClick: () => {
            setCheckedSortOption(item.value);
          },
        }))}
      />

      <Box gap="8px">
        {secondButton}
        <Button leadingIcon="search" onClick={setSearch} />
      </Box>

      {/* {useIsMobile && <Background onClick={handleClickSwipe} />} */}
      {searchOpen && (
        <SearchbarWrapper>
          <Input
            type="search"
            placeholder={searchPlaceholder}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            value={searchTerm}
            autoFocus
          />
        </SearchbarWrapper>
      )}
    </Wrapper>
  );
};

export default Toolbar;
